import React from 'react';

const VideoIntro: React.FC = () => {
  return (
    <section style={{ 
      padding: '4rem 2rem', 
      backgroundColor: '#f8f9fa',
      textAlign: 'center'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h2 style={{ 
          fontSize: '2.5rem', 
          marginBottom: '1rem', 
          color: '#333' 
        }}>
          Meet Natalie
        </h2>
        <p style={{ 
          fontSize: '1.2rem', 
          marginBottom: '2rem', 
          color: '#666' 
        }}>
          Get to know me personally and learn about my approach to helping you achieve your goals.
        </p>
        <video 
          controls 
          preload="metadata"
          style={{ 
            width: '100%', 
            maxWidth: '600px', 
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
          }}
        >
          <source src="/video.mp4" type="video/mp4" />
          <source src="/video.mov" type="video/quicktime" />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  );
};

export default VideoIntro;